const storybookEnv = process.env.STORYBOOK_ENV
    ? process.env.STORYBOOK_ENV
    : 'development';

const envPrefix = storybookEnv + '_';

module.exports={storybookEnv, envPrefix}
